/**
 * Cyber-Minimal KeyboardKey Component
 * 
 * @param {Object} props
 * @param {string} props.code - event.code (e.g., 'KeyA')
 * @param {string} props.label - Key label (e.g., 'A')
 * @param {string} props.state - 'idle' | 'active' | 'history' | 'stuck' | 'chatter'
 */
export function createKeyboardKey({ code, label, gridColumn, gridRow, state = 'idle' }) {
  const key = document.createElement('div');
  key.className = `cm-key cm-key--${state} notranslate`;
  key.setAttribute('translate', 'no');
  key.dataset.code = code;

  // Apply grid positioning
  if (gridColumn) key.style.gridColumn = gridColumn;
  if (gridRow) key.style.gridRow = gridRow;

  // Apply specific styles for long-label keys
  if (label.length > 3) {
    key.style.fontSize = '8px';
  }

  const labelEl = document.createElement('span');
  labelEl.className = 'cm-key__label';
  labelEl.textContent = label;

  // Press count badge (top-right corner, shown after first press)
  const countEl = document.createElement('span');
  countEl.className = 'cm-key__count';
  countEl.textContent = '';

  key.appendChild(labelEl);
  key.appendChild(countEl);

  return key;
}
